<template>
    <div :class="stateClasses" class="field field--check">
        <label v-if="label" :for="name" class="field__label">
            <input
                :name="name"
                :id="name"
                :value="newValue"
                v-bind="$attrs"
                type="checkbox"
                class="field__input"
                @change="onChange"
            />
            <small>{{ label }} <span v-if="required">*</span></small>
        </label>
        <template v-if="error">
            <span class="field__message">
                <small>{{ error }}</small>
            </span>
        </template>
    </div>
</template>

<script>
export default {
    name: 'Checkbox',
    props: {
        value: {
            type: Boolean,
            default: false
        },
        label: {
            type: String,
            default: null,
            required: false
        },
        name: {
            type: String,
            default: '',
            required: true
        },
        required: {
            type: Boolean,
            default: false,
            required: false
        },
        error: {
            type: String,
            default: null
        }
    },
    /**
     * Add all the properties found in the data object to Vue’s reactivity system.
     *
     * @return {object}
     */
    data() {
        return {
            newValue: this.value
        };
    },
    computed: {
        /**
         * Generate the state classes.
         *
         * @return {object}
         */
        stateClasses() {
            return {
                'has-error': this.error
            };
        }
    },
    watch: {
        /**
         * When v-model is changed:
         *   1. Set internal value.
         *   2. If it's invalid, validate again.
         *
         * @param {string} value
         */
        value(value) {
            this.newValue = value;
        },

        /**
         * Update the v-model and validate again whenever
         * internal value is changed.
         *
         * @param {string} value
         */
        newValue(value) {
            this.$emit('input', value);
        }
    },
    methods: {
        /**
         * Checkbox's 'change' event listener, 'nextTick' is used to prevent event firing
         * before ui update, helps when using masks (Cleavejs and potentially others).
         *
         * @param {object} event
         */
        onChange(event) {
            this.$nextTick(() => {
                this.newValue = event.target.checked;
            });
        }
    }
};
</script>
